import React, { useState, useEffect, useRef } from 'react';
import '../App.css';


const EditText = ({ text, onChange, defaultText = '', style = {} }) => {
  const [inputValue, setInputValue] = useState(defaultText);
  const [isEmpty, setIsEmpty] = useState(defaultText === '');

  useEffect(() => {
    setInputValue(defaultText);
    setIsEmpty(defaultText === '');
  }, [defaultText]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    setIsEmpty(newValue === '');
    onChange(newValue);
  };

  return (
    <textarea
      className={`edit-text ${isEmpty ? 'placeholder' : ''}`}
      value={inputValue}
      placeholder={text}
      onChange={handleInputChange}
      style={{
        color: isEmpty ? 'gray' : 'black',
        resize: 'vertical',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        ...style
      }}
    />
  );
};

export default EditText;

